const PERMISSION_KEY= "personalize:nebula_ultra_fees";
const PAGE_URL = {
    NEBULA_ULTRA_FEES_PAGE: "/admin/personalize/nebula-ultra-fees"
}

export {PERMISSION_KEY, PAGE_URL}

